import {
  CurrentUserAction,
  RECEIVE_LINKED_ACCOUNTS,
  REQUEST_LINKED_ACCOUNTS,
  UPDATE_USER,
  UPDATE_USER_PROFILE
} from '@Actions/currentUserActions';

import { ILinkedAccountModel, IUserModel, IUserProfileModel } from '@Shared/models';

interface ICurrentUserState {
  user: IUserModel;
  userProfile: IUserProfileModel;
  cards: ILinkedAccountModel[];
}

export const defaultState: ICurrentUserState = {
  user: window.USER,
  userProfile: window.USER_PROFILE,
  cards: null
};

export function currentUserReducer(state = defaultState, action: CurrentUserAction) {
  switch (action.type) {
    case UPDATE_USER:
      return { ...state, user: { ...state.user, ...action.payload } };
    case UPDATE_USER_PROFILE:
      return { ...state, userProfile: { ...state.userProfile, ...action.payload } };
    case RECEIVE_LINKED_ACCOUNTS:
      return { ...state, cards: action.linkedAccounts };
    case REQUEST_LINKED_ACCOUNTS:
      return { ...state, cards: null };
    default:
      return state;
  }
}
